
(function(){

  function positiveInteger(value, fallback){
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function stepperRule(tr){
    var minimum = positiveInteger(tr && tr.dataset.min, 1);
    var increment = positiveInteger(tr && tr.dataset.step, 1);
    var rawMaximum = parseInt(tr && tr.dataset.max, 10);
    var maximum = Number.isFinite(rawMaximum) && rawMaximum > 0 ? rawMaximum : null;
    if(maximum !== null && maximum < minimum) maximum = minimum;
    return {minimum:minimum, increment:increment, maximum:maximum};
  }

  function normalizeStepperQuantity(value, rule){
    var quantity = parseInt(value, 10);
    if(!Number.isFinite(quantity) || quantity <= 0) return 0;
    if(quantity < rule.minimum) quantity = rule.minimum;
    quantity = rule.minimum + Math.round((quantity - rule.minimum) / rule.increment) * rule.increment;
    if(rule.maximum !== null) quantity = Math.min(quantity, rule.maximum);
    return Math.max(rule.minimum, quantity);
  }

  function nextStepperQuantity(current, direction, rule){
    var quantity = normalizeStepperQuantity(current, rule);
    if(direction > 0){
      if(quantity === 0) return rule.minimum;
      var increased = quantity + rule.increment;
      return rule.maximum !== null && increased > rule.maximum ? quantity : increased;
    }
    if(quantity <= rule.minimum) return 0;
    var decreased = quantity - rule.increment;
    return decreased < rule.minimum ? 0 : decreased;
  }

  // If a buyer taps before the initial /cart.js request returns, the markup
  // may still show zero while Shopify already has units in the cart. Preserve
  // the buyer's visible step delta and rebase it onto that first confirmed
  // quantity before the staged write is sent.
  function rebaseStepperDelta(confirmed, renderedBase, optimistic, rule){
    var base = parseInt(renderedBase, 10) || 0;
    var desired = parseInt(optimistic, 10) || 0;
    return normalizeStepperQuantity((parseInt(confirmed, 10) || 0) + desired - base, rule);
  }

  // Klaviyo popup hooks are semantic; generated kl-private-reset classes are intentionally ignored.
  var klaviyoPopupSelector = '[data-kl-scroll-locking-modal], [role="dialog"][aria-label="POPUP Form"], dialog[aria-label="POPUP Form"], [data-testid="POPUP"]';
  function suppressKlaviyoPopups(root){
    var scope = root && root.querySelectorAll ? root : document;
    var popups = [];
    if(scope.nodeType === 1 && scope.matches(klaviyoPopupSelector)) popups.push(scope);
    scope.querySelectorAll(klaviyoPopupSelector).forEach(function(popup){ popups.push(popup); });
    if(popups.length === 0) return;
    popups.forEach(function(popup){
      if(popup.contains(document.activeElement)) document.activeElement.blur();
      popup.setAttribute('aria-hidden', 'true');
      popup.remove();
    });
    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }
  suppressKlaviyoPopups(document);
  new MutationObserver(function(mutations){
    mutations.forEach(function(mutation){
      if(mutation.type === 'attributes'){
        // Klaviyo's own popup scripts sometimes re-apply overflow:hidden as a
        // style-attribute mutation on an element already in the DOM, not by
        // inserting a new popup node -- that bypasses the addedNodes branch
        // below and left the page permanently unscrollable. Clear it directly
        // rather than routing through suppressKlaviyoPopups(), which only
        // clears overflow when it also finds a matching popup element to
        // remove.
        document.documentElement.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');
        return;
      }
      mutation.addedNodes.forEach(function(node){
        if(node.nodeType === 1) suppressKlaviyoPopups(node);
      });
    });
  }).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['style']});

  // $200 earns free shipping; it never determines whether an order can submit.
  var FREE_SHIP_THRESHOLD_CENTS = 20000;
  // This is a planning estimate, not a carrier quote. It mirrors the existing
  // wholesale-kiosk model: a modest handling base plus a value-based component.
  var ESTIMATED_SHIP_BASE_CENTS = 850;
  var ESTIMATED_SHIP_RATE = 0.05;
  var money = function(cents){
    return new Intl.NumberFormat('en-US',{style:'currency',
      currency:document.body.dataset.currency||'USD'}).format((cents||0)/100);
  };
  var toastEl = document.getElementById('toast');
  var toastTimer;
  function toast(msg, actionLabel, action){
    if(!toastEl) return;
    while(toastEl.firstChild) toastEl.removeChild(toastEl.firstChild);
    var message = document.createElement('span');
    message.textContent = msg;
    toastEl.appendChild(message);
    if(actionLabel && action){
      var actionButton = document.createElement('button');
      actionButton.type = 'button';
      actionButton.className = 'toast-action';
      actionButton.textContent = actionLabel;
      actionButton.addEventListener('click', function(){
        toastEl.classList.remove('show');
        clearTimeout(toastTimer);
        action();
      });
      toastEl.appendChild(actionButton);
    }
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toastEl.classList.remove('show'); }, action ? 8000 : 2400);
  }

  function refreshCart(){
    return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){
      if(!r.ok) throw new Error('cart refresh failed: ' + r.status);
      return r.json();
    }).then(paint);
  }

  function cartUpdateErrorMessage(err){
    if(err && err.status === 422){
      var detail = String(err.description || err.message || '').toLowerCase();
      var unavailable = /unavailable|sold out|out of stock|not available|inventory|stock/.test(detail);
      return unavailable
        ? 'This item is unavailable. Your cart was not changed.'
        : 'That quantity is not allowed for this item. Your cart was not changed.';
    }
    return "We couldn't confirm the cart update. Refresh cart to check your order.";
  }

  // Matches both catalog/review table rows (tr[data-vid]) and kiosk tile
  // cards (div[data-vid]) so one paint()/stepper pipeline drives every view.
  var rows = function(){ return Array.prototype.slice.call(
    document.querySelectorAll('[data-vid]')); };

  // Paint the $200 free-shipping progress bar shown wherever a buyer can add
  // units (catalog ticket, review ticket, kiosk cart bar) via the shared
  // .ship-progress skeleton (bbw-ship-progress snippet).
  function estimatedShippingCents(subtotal){
    subtotal = Math.max(0, parseInt(subtotal, 10) || 0);
    if(subtotal === 0 || subtotal >= FREE_SHIP_THRESHOLD_CENTS) return 0;
    return ESTIMATED_SHIP_BASE_CENTS + Math.round(subtotal * ESTIMATED_SHIP_RATE);
  }

  function paintShipProgress(cart){
    var subtotal = cart.total_price || 0;
    var unlocked = subtotal >= FREE_SHIP_THRESHOLD_CENTS;
    var pct = Math.max(0, Math.min(100, Math.round(subtotal / FREE_SHIP_THRESHOLD_CENTS * 100)));
    document.querySelectorAll('.ship-progress').forEach(function(box){
      box.classList.toggle('unlocked', unlocked);
      var fill = box.querySelector('.ship-progress-fill');
      if(fill) fill.style.width = pct + '%';
      var label = box.querySelector('.ship-progress-label');
      if(label){
        label.textContent = unlocked
          ? '\u2713 Free shipping unlocked'
          : 'Add ' + money(FREE_SHIP_THRESHOLD_CENTS - subtotal) + ' more for free shipping';
      }
    });
    // A buyer may submit any confirmed, non-empty cart. The shipping threshold
    // only changes the shipping estimate and encouragement copy.
    document.querySelectorAll('[data-submit-gate]').forEach(function(btn){
      btn.disabled = !canSubmitCart(cart);
    });
    return unlocked;
  }

  // A confirmed cart comes only from Shopify. Pending quantities are a tiny,
  // per-variant overlay so a button press has immediate visible feedback while
  // the authoritative request is still in flight.
  var confirmedCart = null;
  var pendingByVariant = {};
  var globalCartMutationPending = false;

  function hasOwn(object, key){
    return Object.prototype.hasOwnProperty.call(object, String(key));
  }

  function unitPriceFor(variantId){
    var matching = document.querySelector('[data-vid="' + String(variantId) + '"]');
    return parseInt(matching && matching.dataset.unit, 10) || 0;
  }

  // Shopify's cart only accepts unit quantities. A case-mode row therefore
  // displays a case count but always stages the corresponding unit count.
  // The selected display mode is browser-session UI state, not a cart line
  // property: fulfillment sees the unambiguous unit total Shopify stores.
  function caseSizeFor(tr){
    return positiveInteger(tr && tr.dataset.caseSize, 0);
  }

  function orderModeStorageKey(tr){
    return 'bbw-order-mode:' + String(tr && tr.dataset.vid || '');
  }

  function readStoredOrderMode(tr){
    try { return window.sessionStorage.getItem(orderModeStorageKey(tr)); }
    catch(_err) { return null; }
  }

  function storeOrderMode(tr, mode){
    try { window.sessionStorage.setItem(orderModeStorageKey(tr), mode); }
    catch(_err) { /* Session storage is only a convenience. */ }
  }

  function orderModeFor(tr){
    if(caseSizeFor(tr) === 0) return 'unit';
    if(tr && tr.dataset.orderMode === 'case') return 'case';
    return readStoredOrderMode(tr) === 'case' ? 'case' : 'unit';
  }

  function quantityForDisplay(tr, cartUnits){
    var units = Math.max(0, parseInt(cartUnits, 10) || 0);
    var caseSize = caseSizeFor(tr);
    return orderModeFor(tr) === 'case' && caseSize > 0 ? units / caseSize : units;
  }

  function cartUnitsFromDisplay(tr, displayedQuantity){
    var displayed = Math.max(0, parseInt(displayedQuantity, 10) || 0);
    var caseSize = caseSizeFor(tr);
    return orderModeFor(tr) === 'case' && caseSize > 0 ? displayed * caseSize : displayed;
  }

  function orderStepperRule(tr){
    var rule = stepperRule(tr);
    var caseSize = caseSizeFor(tr);
    if(orderModeFor(tr) !== 'case' || caseSize === 0) return rule;
    return {
      minimum: 1,
      increment: 1,
      maximum: rule.maximum === null ? null : Math.floor(rule.maximum / caseSize)
    };
  }

  function canUseCaseMode(tr){
    var caseSize = caseSizeFor(tr);
    var maximum = stepperRule(tr).maximum;
    return caseSize > 0 && (maximum === null || maximum >= caseSize);
  }

  function effectiveCartQuantity(tr){
    var variantId = String(tr && tr.dataset.vid || '');
    if(hasOwn(pendingByVariant, variantId)) return pendingByVariant[variantId].desired;
    if(confirmedCart) return confirmedQuantity(confirmedCart, variantId);
    if(tr && tr.dataset.confirmedQty !== undefined){
      return parseInt(tr.dataset.confirmedQty, 10) || 0;
    }
    var input = tr && tr.querySelector('input[data-i]');
    return cartUnitsFromDisplay(tr, input && input.value);
  }

  function setOrderMode(tr, mode){
    if(!tr || mode === orderModeFor(tr)) return;
    if(mode === 'case' && !canUseCaseMode(tr)){
      toast('This item cannot be ordered as a full case under its current quantity limit.');
      return;
    }
    var cartUnits = effectiveCartQuantity(tr);
    var caseSize = caseSizeFor(tr);
    if(mode === 'case' && cartUnits % caseSize !== 0){
      toast('This line has individual units. Adjust it to a full case before switching to cases.');
      return;
    }
    tr.dataset.orderMode = mode;
    storeOrderMode(tr, mode);
    var input = tr.querySelector('input[data-i]');
    if(input) input.value = quantityForDisplay(tr, cartUnits);
    paintOptimistic();
  }

  function paintOrderMode(tr){
    var caseSize = caseSizeFor(tr);
    if(caseSize === 0) return;
    var mode = orderModeFor(tr);
    var caseAllowed = canUseCaseMode(tr);
    if(mode === 'case' && !caseAllowed){
      mode = 'unit';
      tr.dataset.orderMode = mode;
      storeOrderMode(tr, mode);
    }
    tr.querySelectorAll('button[data-order-mode]').forEach(function(button){
      var active = button.dataset.orderMode === mode;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.disabled = button.dataset.orderMode === 'case' && !caseAllowed;
    });
    var input = tr.querySelector('input[data-i]');
    if(input) input.setAttribute('aria-label', mode === 'case' ? 'Cases' : 'Units');
    var note = tr.querySelector('[data-case-order-note]');
    if(note){
      note.hidden = mode !== 'case';
      note.textContent = '1 case = ' + caseSize + ' units · ' + money(caseSize * unitPriceFor(tr.dataset.vid));
    }
  }

  // Kept free of DOM state so the arithmetic can be executed as a contract
  // test. It supplies immediate ticket totals without pretending the server
  // accepted a change that has not yet been confirmed.
  function projectCartQuantities(cart, pending, priceFor){
    var quantities = {};
    var itemCount = 0;
    var totalPrice = cart && cart.total_price || 0;
    (cart && cart.items || []).forEach(function(item){
      var variantId = String(item.variant_id);
      var quantity = parseInt(item.quantity, 10) || 0;
      quantities[variantId] = quantity;
      itemCount += quantity;
    });
    Object.keys(pending || {}).forEach(function(variantId){
      var desired = Math.max(0, parseInt(pending[variantId].desired, 10) || 0);
      var confirmed = quantities[variantId] || 0;
      quantities[variantId] = desired;
      itemCount += desired - confirmed;
      totalPrice += (desired - confirmed) * (priceFor(variantId) || 0);
    });
    return {quantities:quantities, itemCount:itemCount, totalPrice:totalPrice};
  }

  // The initial cart refresh is intentionally asynchronous. Seed only the
  // visible quantities for the short interval before it returns, then replace
  // that seed with Shopify's cart response. This avoids a click being visibly
  // swallowed on a slow first load.
  function cartSeedFromRows(){
    var items = [];
    var seen = {};
    var itemCount = 0;
    var totalPrice = 0;
    rows().forEach(function(tr){
      var variantId = String(tr.dataset.vid);
      if(seen[variantId]) return;
      seen[variantId] = true;
      var input = tr.querySelector('input[data-i]');
      var quantity = cartUnitsFromDisplay(tr, input && input.value);
      var unitPrice = unitPriceFor(variantId);
      items.push({variant_id:variantId, quantity:quantity});
      itemCount += quantity;
      totalPrice += quantity * unitPrice;
    });
    return {items:items, item_count:itemCount, total_price:totalPrice};
  }

  function paintOptimistic(){
    paint(confirmedCart || cartSeedFromRows(), false);
  }

  function hasPendingCartWrites(){
    return globalCartMutationPending || Object.keys(pendingByVariant).length > 0;
  }

  function canSubmitCart(cart){
    return confirmedCart !== null && !hasPendingCartWrites() && (cart.item_count || 0) > 0;
  }

  function currentCartCanSubmit(){
    if(!confirmedCart) return false;
    return canSubmitCart(confirmedCart);
  }

  function confirmedQuantity(cart, variantId){
    var item = (cart.items || []).filter(function(candidate){
      return String(candidate.variant_id) === String(variantId);
    })[0];
    return item ? parseInt(item.quantity, 10) || 0 : 0;
  }

  function rebasePendingFirstLoadDeltas(cart){
    Object.keys(pendingByVariant).forEach(function(variantId){
      var state = pendingByVariant[variantId];
      if(!state || !state.rebaseOnFirstCart) return;
      var row = document.querySelector('[data-vid="' + variantId + '"]');
      if(!row) return;
      state.desired = rebaseStepperDelta(
        confirmedQuantity(cart, variantId), state.renderedBase, state.desired, stepperRule(row)
      );
      state.rebaseOnFirstCart = false;
    });
  }

  function paintLastConfirmedVisibleState(variantId){
    rows().forEach(function(tr){
      if(String(tr.dataset.vid) !== String(variantId)) return;
      var input = tr.querySelector('input[data-i]');
      if(input) input.value = quantityForDisplay(tr, tr.dataset.confirmedQty || '0');
    });
    paint(cartSeedFromRows(), false);
  }

  // Re-render every stepper, line total and the ticket from a /cart.js payload.
  function setStepperPending(tr, pending){
    var minus = tr.querySelector('button[data-m]');
    var plus = tr.querySelector('button[data-p]');
    var input = tr.querySelector('input[data-i]');
    var displayedQuantity = parseInt(input && input.value,10) || 0;
    var rule = orderStepperRule(tr);
    tr.classList.toggle('busy', pending);
    if(pending) tr.setAttribute('aria-busy','true');
    else tr.removeAttribute('aria-busy');
    // Keep the affected control responsive during a request: rapid +/- taps
    // coalesce into one later absolute Shopify update. Only natural boundaries
    // (zero and a server-provided maximum) disable a button.
    if(minus) minus.disabled = displayedQuantity === 0;
    if(plus) plus.disabled = rule.maximum !== null && displayedQuantity >= rule.maximum;
    if(input) input.disabled = false;
  }

  function paint(cart, isServerCart){
    if(isServerCart !== false){
      var firstConfirmedCart = confirmedCart === null;
      confirmedCart = cart;
      if(firstConfirmedCart) rebasePendingFirstLoadDeltas(cart);
    }
    var projection = projectCartQuantities(cart, pendingByVariant, unitPriceFor);
    var byId = {};
    (cart.items||[]).forEach(function(i){ byId[String(i.variant_id)] = i; });
    var lines = 0;
    rows().forEach(function(tr){
      var variantId = String(tr.dataset.vid);
      var item = byId[variantId];
      var confirmedUnits = item ? item.quantity : 0;
      var units = projection.quantities[variantId] || 0;
      var caseSize = caseSizeFor(tr);
      if(orderModeFor(tr) === 'case' && (caseSize === 0 || units % caseSize !== 0)){
        tr.dataset.orderMode = 'unit';
        storeOrderMode(tr, 'unit');
      }
      paintOrderMode(tr);
      var unitPrice = parseInt(tr.dataset.unit,10) || 0;
      var input = tr.querySelector('input[data-i]');
      if(input) input.value = quantityForDisplay(tr, units);
      if(!hasOwn(pendingByVariant, variantId)) tr.dataset.confirmedQty = String(confirmedUnits);
      setStepperPending(tr, hasOwn(pendingByVariant, variantId));
      tr.classList.toggle('has-qty', units > 0);
      var lt = tr.querySelector('[data-line]');
      if(lt) lt.innerHTML = units > 0 ? money(units * unitPrice) : '<span class="dim">&mdash;</span>';
      var tag = tr.querySelector('[data-inorder]');
      if(tag) tag.hidden = !(units > 0 && tr.hidden);
      if(units > 0){ lines += 1; }
    });
    var set = function(id, val){ var e = document.getElementById(id); if(e) e.textContent = val; };
    set('tUnits', projection.itemCount.toLocaleString());
    set('tLines', lines);
    var shippingEstimate = estimatedShippingCents(projection.totalPrice);
    var reviewTicket = document.getElementById('tSubtotal');
    if(reviewTicket){
      set('tSubtotal', money(projection.totalPrice));
      set('tShipping', shippingEstimate ? money(shippingEstimate) : 'Free');
      set('tTotal', money(projection.totalPrice + shippingEstimate));
    } else {
      set('tTotal', money(projection.totalPrice));
    }
    var projectedCart = {item_count:projection.itemCount, total_price:projection.totalPrice};
    var unlocked = paintShipProgress(projectedCart);
    var co = document.getElementById('checkout');
    if(co){
      var checkoutReady = canSubmitCart(projectedCart);
      co.disabled = !checkoutReady;
      co.setAttribute('aria-disabled', checkoutReady ? 'false' : 'true');
    }
    var nb = document.getElementById('navUnits');
    if(nb){ nb.hidden = projection.itemCount === 0; nb.textContent = projection.itemCount.toLocaleString(); }

    // A sighted buyer sees the ticket move. Without this a screen-reader buyer
    // gets no confirmation that pressing + did anything at all.
    var live = document.getElementById('ticketLive');
    if(live){
      live.textContent = projection.itemCount === 0
        ? 'Order is empty.'
        : projection.itemCount + (projection.itemCount === 1 ? ' unit, ' : ' units, ') +
          'subtotal ' + money(projection.totalPrice) + '.' +
          (unlocked ? ' Free shipping unlocked.' : '');
    }
  }

  function recoverVariant(variantId, err){
    delete pendingByVariant[String(variantId)];
    if(confirmedCart) paintOptimistic();
    else paintLastConfirmedVisibleState(variantId);
    toast(cartUpdateErrorMessage(err), 'Refresh cart', function(){
      refreshCart().catch(function(refreshErr){
        toast("Couldn't refresh the cart. Try again.");
        if(window.console) console.error(refreshErr);
      });
    });
    if(window.console) console.error(err);
    // Re-read after every failed write. The immediate rollback is the last
    // confirmed server cart; this follow-up protects against another tab or a
    // server-side rule changing during the request.
    return refreshCart().catch(function(refreshErr){
      paintOptimistic();
      if(window.console) console.error(refreshErr);
    });
  }

  function write(variantId, units){
    var body = {}; body[variantId] = units;
    return fetch('/cart/update.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({updates: body})
    }).then(function(r){
      if(r.ok) return r.json();
      return r.json().catch(function(){ return {}; }).then(function(errorBody){
        var error = new Error(errorBody.description || errorBody.message || 'cart update failed: ' + r.status);
        error.status = r.status;
        error.description = errorBody.description || errorBody.message || '';
        throw error;
      });
    });
  }

  function stepToUnits(tr, nextUnits){
    var rule = stepperRule(tr);
    nextUnits = normalizeStepperQuantity(nextUnits, rule);
    if(rule.maximum === null && nextUnits > 9999){
      nextUnits = rule.minimum + Math.floor((9999 - rule.minimum) / rule.increment) * rule.increment;
    }
    return nextUnits;
  }

  // Every server cart write stays on one chain. Within a single variant, rapid
  // presses are coalesced: the buyer sees each unit immediately, while Shopify
  // receives the latest absolute quantity rather than a slow request per tap.
  var chain = Promise.resolve();
  function queue(fn){ chain = chain.then(fn).catch(function(){}); return chain; }

  function scheduleVariantWrite(variantId, delay){
    var state = pendingByVariant[String(variantId)];
    if(!state) return;
    state.needsFlush = true;
    clearTimeout(state.timer);
    state.timer = setTimeout(function(){
      state.timer = null;
      enqueueVariantWrite(String(variantId));
    }, delay === undefined ? 90 : delay);
  }

  function enqueueVariantWrite(variantId){
    var state = pendingByVariant[variantId];
    if(!state || state.enqueued || state.inFlight || !state.needsFlush) return;
    state.enqueued = true;
    return queue(function(){
      state = pendingByVariant[variantId];
      if(!state) return;
      state.enqueued = false;
      if(state.inFlight || !state.needsFlush) return;
      state.inFlight = true;
      state.needsFlush = false;
      var requested = state.desired;
      return write(variantId, requested).then(function(cart){
        confirmedCart = cart;
        state = pendingByVariant[variantId];
        if(!state) { paint(cart); return; }
        state.inFlight = false;
        if(state.desired === requested){
          delete pendingByVariant[variantId];
        } else {
          state.needsFlush = true;
          scheduleVariantWrite(variantId, 0);
        }
        paint(cart);
      }).catch(function(err){
        return recoverVariant(variantId, err);
      });
    });
  }

  function flushPendingVariantWrites(){
    Object.keys(pendingByVariant).forEach(function(variantId){
      var state = pendingByVariant[variantId];
      if(!state) return;
      clearTimeout(state.timer);
      state.timer = null;
      state.needsFlush = true;
      enqueueVariantWrite(variantId);
    });
    return chain;
  }

  function beginGlobalCartMutation(){
    globalCartMutationPending = true;
    paintOptimistic();
    return flushPendingVariantWrites();
  }

  function endGlobalCartMutation(cart){
    globalCartMutationPending = false;
    if(cart) paint(cart);
    else paintOptimistic();
  }

  function stageQuantity(tr, nextUnits, rebaseDelta){
    if(globalCartMutationPending){
      toast('Finishing the cart update first.');
      return;
    }
    var variantId = String(tr.dataset.vid);
    // Preserve the rendered server quantity before an optimistic repaint. It
    // is the fallback if the first cart refresh and the attempted write both
    // fail before a confirmed /cart.js payload is available.
    if(!tr.dataset.confirmedQty){
      var currentInput = tr.querySelector('input[data-i]');
      tr.dataset.confirmedQty = String(cartUnitsFromDisplay(tr, currentInput && currentInput.value));
    }
    var renderedBase = parseInt(tr.dataset.confirmedQty,10) || 0;
    var state = pendingByVariant[variantId] || {
      desired:renderedBase,
      renderedBase:renderedBase,
      rebaseOnFirstCart:false
    };
    state.desired = stepToUnits(tr, nextUnits);
    if(rebaseDelta && confirmedCart === null){
      state.rebaseOnFirstCart = true;
    } else if(!rebaseDelta){
      // Typed values are explicit absolute quantities, not relative clicks.
      state.rebaseOnFirstCart = false;
    }
    pendingByVariant[variantId] = state;
    paintOptimistic();
    scheduleVariantWrite(variantId);
  }

  document.addEventListener('click', function(e){
    var modeButton = e.target.closest('button[data-order-mode]');
    if(modeButton){
      e.preventDefault();
      var modeRow = modeButton.closest('tr[data-vid]') || modeButton.closest('[data-vid]');
      setOrderMode(modeRow, modeButton.dataset.orderMode);
      return;
    }
    var plus = e.target.closest('button[data-p]');
    var minus = e.target.closest('button[data-m]');
    if(!plus && !minus) return;
    e.preventDefault();
    var tr = e.target.closest('tr[data-vid]') || e.target.closest('[data-vid]');
    if(!tr) return;
    var cur = parseInt(tr.querySelector('input[data-i]').value,10) || 0;
    stageQuantity(
      tr,
      cartUnitsFromDisplay(tr, nextStepperQuantity(cur, plus ? 1 : -1, orderStepperRule(tr))),
      true
    );
  });

  document.addEventListener('change', function(e){
    var input = e.target.closest('input[data-i]');
    if(!input) return;
    var tr = input.closest('tr[data-vid]') || input.closest('[data-vid]');
    var typed = parseInt(input.value,10) || 0;
    stageQuantity(tr, cartUnitsFromDisplay(tr, typed), false);
  });

  // Search + family filter. Rows already in the order stay visible whatever the
  // filter says — charging for a line the buyer cannot see or remove is a trap.
  var q = document.getElementById('q');
  var filter = 'all';
  function applyFilter(){
    var term = (q && q.value || '').trim().toLowerCase();
    var shown = 0;
    var groups = {};
    rows().forEach(function(tr){
      var inOrder = tr.classList.contains('has-qty');
      var hay = (tr.dataset.search || '').toLowerCase();
      var hideSearch = term && hay.indexOf(term) === -1;
      var hideFilter = (filter === 'stock' && tr.classList.contains('oos')) ||
        (filter !== 'all' && filter !== 'stock' && tr.dataset.group !== filter);
      var hidden = (hideSearch || hideFilter) && !inOrder;
      tr.hidden = hidden;
      var tag = tr.querySelector('[data-inorder]');
      if(tag) tag.hidden = !(inOrder && (hideSearch || hideFilter));
      if(!hidden){ shown++; groups[tr.dataset.group] = true; }
    });
    document.querySelectorAll('tr.grp').forEach(function(g){
      g.hidden = !groups[g.dataset.group];
    });
    var none = document.getElementById('noMatch');
    if(none) none.hidden = shown > 0;
  }
  if(q){
    q.addEventListener('input', applyFilter);
    document.addEventListener('keydown', function(e){
      if(e.key === '/' && document.activeElement !== q){ e.preventDefault(); q.focus(); }
    });
  }
  document.querySelectorAll('.chip[data-f]').forEach(function(c){
    c.addEventListener('click', function(){
      document.querySelectorAll('.chip[data-f]').forEach(function(x){ x.classList.remove('on'); });
      c.classList.add('on');
      filter = c.dataset.f;
      applyFilter();
    });
  });

  var clear = document.getElementById('clearAll');
  if(clear) clear.addEventListener('click', function(){
    if(globalCartMutationPending) return;
    clear.disabled = true;
    beginGlobalCartMutation();
    queue(function(){
      return fetch('/cart/clear.js',{method:'POST',credentials:'same-origin'})
        .then(function(r){ return r.json(); }).then(function(cart){
          endGlobalCartMutation(cart); toast('Order cleared.');
        }).catch(function(err){
          endGlobalCartMutation();
          toast("Couldn't clear the cart. Refresh cart to check your order.");
          if(window.console) console.error(err);
          return refreshCart().catch(function(refreshErr){
            if(window.console) console.error(refreshErr);
          });
        }).then(function(){
          clear.disabled = false;
        });
    });
  });

  // Kiosk starter packs: several SKUs added in one /cart/add.js call, which is
  // additive (unlike /cart/update.js). A buyer who already has some of an item
  // in their order keeps it -- the pack tops it up rather than overwriting it.
  document.querySelectorAll('[data-starter]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var pairs = (btn.dataset.items || '').split(',');
      var items = [];
      pairs.forEach(function(p){
        var parts = p.split(':');
        var vid = parseInt(parts[0],10);
        var qty = parseInt(parts[1],10) || 0;
        if(vid && qty > 0) items.push({ id: vid, quantity: qty });
      });
      if(items.length === 0) return;
      if(globalCartMutationPending) return;
      beginGlobalCartMutation();
      queue(function(){
        btn.disabled = true;
        var label = btn.textContent;
        btn.textContent = 'Adding\u2026';
        return fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items: items })
        }).then(function(r){
          if(!r.ok) throw new Error('starter pack add failed: ' + r.status);
          return fetch('/cart.js', {credentials:'same-origin'});
        }).then(function(r){ return r.json(); }).then(function(cart){
          endGlobalCartMutation(cart); toast('Starter pack added.');
        }).catch(function(err){
          endGlobalCartMutation();
          toast("Couldn't add the starter pack \u2014 nothing was changed.");
          if(window.console) console.error(err);
          return refreshCart().catch(function(refreshErr){
            if(window.console) console.error(refreshErr);
          });
        }).then(function(){
          btn.disabled = false; btn.textContent = label;
        });
      });
    });
  });

  function cartSubmissionWaitMessage(){
    return hasPendingCartWrites()
      ? 'Finishing your cart update before checkout.'
      : 'Your cart is still loading or is empty.';
  }

  document.addEventListener('click', function(e){
    var checkoutControl = e.target.closest('#checkout,[data-submit-gate]');
    if(!checkoutControl || currentCartCanSubmit()) return;
    e.preventDefault();
    toast(cartSubmissionWaitMessage());
  });

  // Submit guards. A double click on either form would otherwise create two
  // draft orders, or two application emails, from one intent. Disable on first
  // submit and let the navigation take over.
  document.querySelectorAll('form').forEach(function(form){
    form.addEventListener('submit', function(e){
      if(form.querySelector('#checkout,[data-submit-gate]') && !currentCartCanSubmit()){
        e.preventDefault();
        toast(cartSubmissionWaitMessage());
        return;
      }
      if(form.dataset.submitted === '1'){ return; }
      form.dataset.submitted = '1';
      var btn = form.querySelector('button[type=submit], button[name=checkout]');
      if(btn){
        // The browser builds this submission's form-data set (which is what
        // decides whether Shopify sees name="checkout" and sends the buyer to
        // /checkout, vs. just reloading /cart) immediately after this handler
        // returns, and a disabled submitter is dropped from that set. Disabling
        // synchronously here silently turned every "Submit order" into a dead
        // click that bounced back to the cart. Deferring one tick keeps the
        // button enabled through the real submission; the submitted flag above
        // already blocks a second click.
        btn.dataset.label = btn.textContent;
        btn.textContent = 'Sending\u2026';
        setTimeout(function(){ btn.disabled = true; }, 0);
      }
      // If the browser restores this page from bfcache, re-enable rather than
      // leaving the buyer staring at a dead button.
      window.addEventListener('pageshow', function(e){
        if(e.persisted){
          form.dataset.submitted = '';
          if(btn){ btn.disabled = false; btn.textContent = btn.dataset.label || 'Submit'; }
        }
      });
    });
  });

  // On a phone the wholesale links share one horizontal row. Native tab focus
  // already scrolls that row, and this initial nudge ensures the current route
  // is not hidden off its far edge before the buyer starts navigating.
  function revealActiveMobileNav(){
    if(!window.matchMedia || !window.matchMedia('(max-width: 760px)').matches) return;
    var activeNav = document.querySelector('.nav a.on');
    if(!activeNav || !activeNav.scrollIntoView) return;
    window.requestAnimationFrame(function(){
      activeNav.scrollIntoView({block:'nearest', inline:'nearest'});
    });
  }
  revealActiveMobileNav();

  // Paint once from the live cart so a back-button restore can't show a stale
  // ticket rendered into the HTML at page-cache time.
  if(document.querySelector('[data-vid]') || document.getElementById('tTotal')){
    // Disable any checkout control until this initial cart response makes the
    // current subtotal authoritative.
    paintOptimistic();
    queue(function(){
      return fetch('/cart.js',{credentials:'same-origin'})
        .then(function(r){ return r.json(); }).then(paint);
    });
  }

  // Exposed so view-specific inline scripts (kiosk idle-reset) can repaint
  // after they touch the cart directly, without duplicating paint().
  window.__bbwPaint = paint;
})();
